import PrivateRoomsList from "./PrivateRoomsList";
export default PrivateRoomsList;
